import Polygon from "./Polygon";

export default Polygon;
